import { render, staticRenderFns } from "./ShowStage.vue?vue&type=template&id=b0cc803c&scoped=true&"
import script from "./ShowStage.vue?vue&type=script&lang=js&"
export * from "./ShowStage.vue?vue&type=script&lang=js&"
import style0 from "./ShowStage.vue?vue&type=style&index=0&id=b0cc803c&prod&lang=scss&scoped=true&"
import style1 from "./ShowStage.vue?vue&type=style&index=1&id=b0cc803c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cc803c",
  null
  
)

export default component.exports